import { Card, CardContent } from '@/components/ui/card';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { SectionHeading, EmptySection } from './shared';

interface Props {
  data: any[];
}

export default function WorkforceSection({ data }: Props) {
  const totalPOB = data.reduce((sum, r) => sum + (r.personnel_count ?? 0), 0);

  return (
    <section>
      <SectionHeading id="section-workforce" title="Workforce / Personnel" count={data.length} />
      {data.length === 0 ? (
        <EmptySection name="workforce entries" />
      ) : (
        <Card className="mt-2">
          <CardContent className="p-0">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Company</TableHead>
                  <TableHead>Crew Type</TableHead>
                  <TableHead className="text-right">Headcount</TableHead>
                  <TableHead>Supervisor / SSE</TableHead>
                  <TableHead>Notes</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data.map((row: any) => (
                  <TableRow key={row.id}>
                    <TableCell className="font-medium">{row.company_name}</TableCell>
                    <TableCell>
                      <Badge variant="outline">{row.crew_type?.replace(/_/g, ' ')}</Badge>
                    </TableCell>
                    <TableCell className="text-right">{row.personnel_count}</TableCell>
                    <TableCell>{row.supervisor_name || '—'}</TableCell>
                    <TableCell className="max-w-48 truncate text-muted-foreground">
                      {row.notes || '—'}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow className="bg-muted/30 font-semibold">
                  <TableCell colSpan={2}>Total POB</TableCell>
                  <TableCell className="text-right">{totalPOB}</TableCell>
                  <TableCell colSpan={2} />
                </TableRow>
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      )}
    </section>
  );
}
